module.exports = __webpack_public_path__ + "static/media/Microcentrifuge.afb63e89.svg";